// Helper functions for message processing

export const extractAllImages = (text: string): string[] => {
  // Match both properly formatted tags and orphaned tags
  const imageRegex = /\[IMAGE_URL\]\s*(\S+)(?:\s*\[\/IMAGE_URL\]|\s*\[IMAGE_URL\])?/g;
  const imageUrls = [];
  let match;
  
  while ((match = imageRegex.exec(text)) !== null) {
    // Clean the URL: remove quotes, trailing punctuation, and ensure it's a valid URL
    let rawUrl = match[1].replace(/['"]/g, '');
    // Remove any trailing punctuation marks that shouldn't be part of the URL
    const cleanUrl = rawUrl.replace(/[.,;:!?)\]]*$/, '');
    imageUrls.push(cleanUrl);
  }
  
  return imageUrls;
};

export const extractAllVideos = (text: string): string[] => {
  const videoRegex = /\[VIDEO_URL\]\s*(\S+)(?:\s*\[\/VIDEO_URL\])?/g;
  const videoUrls = [];
  let match;
  
  while ((match = videoRegex.exec(text)) !== null) {
    // Clean the URL: remove quotes, trailing punctuation, and ensure it's a valid URL
    let rawUrl = match[1].replace(/['"]/g, '');
    // Remove any trailing punctuation marks that shouldn't be part of the URL
    const cleanUrl = rawUrl.replace(/[.,;:!?)\]]*$/, '');
    videoUrls.push(cleanUrl);
  }
  
  return videoUrls;
};

export const extractAllFiles = (text: string): string[] => {
  const fileRegex = /\[FILE_NAME\]\s*(\S+)(?:\s*\[\/FILE_NAME\])?/g;
  const fileNames = [];
  let match;
  
  while ((match = fileRegex.exec(text)) !== null) {
    let rawName = match[1].replace(/['"]/g, '');
    // Remove any trailing punctuation marks that shouldn't be part of the filename
    const cleanName = rawName.replace(/[.,;:!?)\]]*$/, '');
    fileNames.push(cleanName);
  }
  
  return fileNames;
};

export const removeMediaUrls = (text: string): string => {
  // Remove properly formatted media tags
  let cleanText = text;
  // Remove image tags with content
  cleanText = cleanText.replace(/\[IMAGE_URL\].*?\[\/IMAGE_URL\]/g, '');
  // Remove video tags with content
  cleanText = cleanText.replace(/\[VIDEO_URL\].*?\[\/VIDEO_URL\]/g, '');
  // Remove file tags with content
  cleanText = cleanText.replace(/\[FILE_NAME\].*?\[\/FILE_NAME\]/g, '');
  // Remove any orphaned opening tags
  cleanText = cleanText.replace(/\[IMAGE_URL\].*?(?=\[IMAGE_URL\]|\[VIDEO_URL\]|$)/g, '');
  cleanText = cleanText.replace(/\[VIDEO_URL\].*?(?=\[IMAGE_URL\]|\[VIDEO_URL\]|$)/g, '');
  cleanText = cleanText.replace(/\[FILE_URL\].*?(?=\[IMAGE_URL\]|\[VIDEO_URL\]|$)/g, '');
  // Remove any orphaned closing tags
  cleanText = cleanText.replace(/\[\/IMAGE_URL\]/g, '');
  cleanText = cleanText.replace(/\[\/VIDEO_URL\]/g, '');
  cleanText = cleanText.replace(/\[\/FILE_URL\]/g, '');

  // REMOVE TOOL_STATUS TAGS
  cleanText = cleanText.replace(/\[TOOL_STATUS\].*?\[\/TOOL_STATUS\]/g, '');
  // REMOVE AUTH_ERROR TAGS
  cleanText = cleanText.replace(/\[AUTH_ERROR\][\s\S]*?\[\/AUTH_ERROR\]/g, '');
  // Remove any remaining tags
  cleanText = cleanText.replace(/\[.*?\]/g, '');
  
  return cleanText.trim();
};
